import { PropsWithChildren } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

const ItemEditorForm = ({ children }: PropsWithChildren) => {

    const formMethods = useForm({
        defaultValues: {
            primaryKey__: '',
        }
    });

    return (
        <FormProvider {...formMethods}>
            <form className="tw-overflow-x-hidden">
                {children}
            </form>
        </FormProvider>
    );
};

ItemEditorForm.displayName = 'ItemEditorForm';

export { ItemEditorForm };
